module.exports = __webpack_public_path__ + "static/media/Banner-About-Internal-Control.91113c06.png";